import {isDate} from "../../utils/functions";
import {DATE_TYPE} from "../../enums/dateType";

/**
 * Mixin used for handling 'Calculate field' conditions.
 */
export default {
  data: function () {
    return {
      moneyPrefix: '$ ',
    }
  },
  mixins: [],
  methods: {
    processCalculation(first, second, type) {
      switch (type) {
        case '1':
          return parseFloat(first) + parseFloat(second);
        case '2':
          return parseFloat(first) - parseFloat(second);
        case '3':
          return parseFloat(first) * parseFloat(second);
        case '4':
          return parseFloat(first) / parseFloat(second);
        case '5':
          return (parseInt(first) / parseInt(second) * 100);
      }
    },

    processDateCalculation(date, amount, type) {
      date = moment(date, DATE_TYPE.BACKEND);
      switch (type) {
        case '1':
          return date.add(amount, 'years');
        case '2':
          return date.subtract(amount, 'years');
        case '11':
          return date.add(amount, 'days');
        case '12':
          return date.subtract(amount, 'days');
      }

      return date;
    },

    getValueForCalculation(field) {
      if (field) {
        const value = this.formData[field.name];
        if (field.type === 'checkbox') {
          return value ? [value] : [];
        } else if (field.type === 'radio-group') {
          return field.values.find(v => v.label === value).value
        } else if (field.type === 'currency') {
          return value ? parseFloat(value.replace(/[^0-9.-]+/g, "")) : 0
        } else if (field.type === 'number') {
          return value || 0
        }
        return value
      }
    },

    renderCalculations() {
      if (this.calculations == null) {
        return;
      }

      this.calculations.forEach(obj => {
        let results, firstFieldName, calc;
        let arraySize = obj.questions.length;

        obj.questions.forEach((obj, idx) => {
          const field = this.fieldByName[obj.field] || null;

          if (obj.field !== '' && idx === 0) {
            // get first value for calculation
            results = (obj.field === 'custom-value') ? obj.value : this.getValueForCalculation(field);
            // save first field name
            firstFieldName = obj.field;
            calc = obj.calculation;
          } else if (idx === arraySize - 1) {
            // check if type is date or is shared field with valid date
            if (
              (
                this.getType(firstFieldName) === 'date' ||
                (this.getType(firstFieldName) === 'shared' && isDate(results))
              )
              &&
              (
                this.getType(obj.field) === 'date' ||
                (this.getType(obj.field) === 'shared' && isDate(this.getValueForCalculation(field)))
              )
            ) {
              let date1 = results ? moment(results, DATE_TYPE.BACKEND) : null;
              let date2 = this.getValueForCalculation(field) ? moment(this.getValueForCalculation(field), DATE_TYPE.BACKEND) : null;

              if (date1 && date2) {
                const period = (parseInt(calc) === 11 || parseInt(calc) === 12) ? 'days' : 'years';
                results = date1.diff(date2, period);
              } else {
                results = 0;
              }
            } else {
              let getField = (obj.field === 'custom-value') ? obj.value : this.getValueForCalculation(field);

              if (this.getType(firstFieldName) === 'date') {
                results = this.processDateCalculation(results, getField, calc);
              } else {
                results = this.processCalculation(results, getField, calc);
              }
            }

          } else {
            let secondFieldValue = (obj.field === 'custom-value') ? obj.value : this.getValueForCalculation(field);
            results = this.processCalculation(results, secondFieldValue, calc);
            calc = obj.calculation;
          }
        });

        if (obj.displayIn) {
          const targetField = this.fieldByName[obj.displayIn]

          if (targetField) {
            if (targetField.type === 'currency' && !Number.isNaN(results)) {
              // CURRENCY FIELD
              this.formData[obj.displayIn] = this.moneyPrefix + parseFloat(results).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (targetField.type !== 'date' && !Number.isNaN(results)) {
              // NUMBER FIELD
              // optional rounding
              if (this.fieldByName[obj.displayIn].hasOwnProperty('decimalSize')){
                results = results.toFixed(this.fieldByName[obj.displayIn].decimalSize);
              }
              this.formData[obj.displayIn] = results;
            } else if (targetField.type === 'date') {
              // DATE FIELD
              let date = moment(results);
              if (date.isValid()) {
                this.formData[obj.displayIn] = results.format(DATE_TYPE.BACKEND);
              } else {
                this.formData[obj.displayIn] = '';
              }
            }
          }
        }
      });

    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formRender/calculationsConditions.js